import { __ } from '@wordpress/i18n';
import { useState, useEffect, useRef } from '@wordpress/element';
import {
	Placeholder,
	Button,
	Dashicon,
	Modal,
	CustomSelectControl,
} from '@wordpress/components';
import { useDispatch, useSelect } from '@wordpress/data';

import classnames from 'classnames';
import {
	setPreviewDeviceType,
	toTitleCase,
} from '../inspector-responsive-label-2';

const InspectorResponsiveLabel = ( props ) => {
	const {
		label = '',
		value,
		currentMedia,
		setCurrentMedia = () => {},
		currentUnit = '',
		setCurrentUnit = () => {},
		onReset = () => {},
		unites = [],
		availableMedia = [ 'Desktop', 'Tablet', 'Mobile' ],
		defaultUnit = '',
		isResetButton = true,
		isMedia = true,
		isUnit = true,
	} = props;

	const deviceType = useSelect( ( select ) => {
		const store = select( 'core/edit-post' );
		const editorStore = select( 'core/editor' );
		let device = '';
		if (
			store &&
			typeof store.__experimentalGetPreviewDeviceType === 'function'
		) {
			device = store.__experimentalGetPreviewDeviceType();
		} else if (
			editorStore &&
			typeof editorStore.getDeviceType === 'function'
		) {
			device = editorStore.getDeviceType();
		}
		return device;
	}, [] );

	const _currentMedia = toTitleCase( deviceType ) || 'Desktop';

	useEffect( () => {
		setCurrentMedia( deviceType?.toLowerCase() );
	}, [ deviceType ] );

	const setMedia = ( media ) => {
		setPreviewDeviceType( media );
		setCurrentMedia( media?.toLowerCase() );
	};

	const reSet = () => {
		if ( onReset ) {
			onReset();
			if ( defaultUnit ) {
				setCurrentUnit( defaultUnit );
			}
		}
	};

	const options = availableMedia
		?.map( ( m ) => toTitleCase( m ) )
		.map( ( media ) => ( {
			key: media,
			name: (
				<Dashicon
					size="15"
					icon={
						media === 'Desktop'
							? 'desktop'
							: media === 'Tablet'
							? 'tablet'
							: 'smartphone'
					}
				></Dashicon>
			),
			style: {},
		} ) );

	const selectedOption = options.find(
		( option ) => option.key === _currentMedia
	);

	return (
		<>
			<div className="flex justify-between mb-2">
				<div className="flex justify-start items-center gap-1">
					<span className="mr-2">{ label }</span>
					{ isMedia && availableMedia?.length > 0 && (
						<CustomSelectControl
							className="unit-select"
							options={ options }
							onChange={ ( { selectedItem } ) =>
								setMedia( selectedItem?.key )
							}
							value={ selectedOption }
							__next40pxDefaultSize
						/>
					) }
				</div>
				<div className="flex justify-end float-right items-center ml-2 text-sm">
					{ isResetButton && (
						<Dashicon
							className="text-gray-400 cursor-pointer transition-colors transition-duration-[300] hover:text-[--wp--preset--color--vivid-cyan-blue]"
							size="15"
							icon="image-rotate"
							onClick={ reSet }
						></Dashicon>
					) }
					<div className="flex items-center justify-center ml-2 text-sm">
						{ isUnit && unites?.length > 0 && (
							<CustomSelectControl
								className="unit-select"
								options={ unites?.map( ( tx ) => ( {
									key: tx,
									name: tx,
									style: {},
								} ) ) }
								onChange={ ( { selectedItem } ) => {
									setCurrentUnit( selectedItem?.key );
								} }
								// value={value?.[currentMedia]?.unit}
								value={ currentUnit }
								__next40pxDefaultSize
							/>
						) }
					</div>
				</div>
			</div>
		</>
	);
};
export default InspectorResponsiveLabel;
